import { QueryClient } from '@tanstack/react-query';

/**
 * TanStack Query client configuration.
 *
 * - staleTime: 5 minutes (data considered fresh for 5 min).
 * - retry: 1 attempt for failed queries (avoids hammering failing endpoints).
 * - refetchOnWindowFocus: true (re-validates stale data when user returns).
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000,
      retry: 1,
      refetchOnWindowFocus: true,
    },
    mutations: {
      retry: 0,
    },
  },
});
